import {SortOrder} from '@/components/base/SortOptions';
import {ContactType} from '@/enums/contact';
import type {IContactListFilterOptions} from '@/models/Contacts';

import {SortOptions} from '../enums';

export const PERMANENT_DELETION_DAYS = 30;
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE_SIZE_FOR_GRID = 10;
export const DEFAULT_PAGE = 1;
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_ITEMS_PER_PAGE = 100;

export const DEFAULT_PAGE_ROWS_FOR_GRID = [5, 10, 15];
export const DEFAULT_ROWS_FOR_GRID = 5;
export const DEFAULT_PAGE_ROWS_FOR_CARDS = [3, 5, 10];
export const DEFAULT_PAGE_SIZE_FOR_CARDS = 10;
export const DEFAULT_PAGE_SIZE_FOR_INFINITE_SCROLL = 20;
export const DEFAULT_SHARD_LOCATION = 'US';
export const DEFAULT_COUNTRY_CODE = 'US';
export const DEFAULT_DIAL_CODE = '+1';
export const DEFAULT_EMAIL_MAX_LENGTH = 120;
export const DEFAULT_CONTACT_FIELDS_MAX_LENGTH = 80;
export const DEFAULT_CONTACT_FIELDS_MIN_LENGTH = 1;
export const TOTAL_MINS_IN_DAY = 1440;

export const LAST_ACTIVE_CONTEXT = 'lastActiveContext';

export const DEFAULT_CONTACT_FILTERS: IContactListFilterOptions = {
  contactType: ContactType.ALL,
  contactOf: '',
  page: DEFAULT_PAGE,
  excludeContactGUIDs: [],
  hideRealContacts: false,
  hiddenRecords: [],
  includeCardQuerys: [],
  includeContactConnection: '',
  sortOptions: [{sortBy: SortOptions.DATE_ADDED, sortOrder: SortOrder.DESCENDING}],
  limit: DEFAULT_PAGE_SIZE,
  search: '',
  excludeSelf: false,
  includePublic: false,
};

export const EMPTY_UUID = '00000000-0000-0000-0000-000000000000';

export const PLATFORM_GUID = 'pppppppp-pppp-pppp-pppp-pppppppppppp';

export const PLATFORM_CONTACT_GUID = 'pcpcpcpc-pcpc-pcpc-pcpc-pcpcpcpcpcpc';
export const ALLOWED_FILE_EXTENSIONS =
  '.doc, .docx, .rtf, .rtfd, .pages, .txt, .pdf, .wpd, .xls, .xlsx, .xlsm, .csv, .numbers, .ods, .ppt, .pptx, .key, .odp, .pps, ai, .bmp, .gif, .jpeg, .jpg, .png, .psd, .svg, .tif, .tiff, .webp, .aif, .mp3, .mpa, .wav, .wma, .flac, .m4a, .avi, .flv, .h264, .m4v, .mkv, .mov, .mp4, .mpg, .mpeg, .webm, .wmv, .7z, .arj, .rar, .z, .tar.gz, .zip, .email, .eml, .emlx, .msg, .app, .exe, .bin, .fnt, .fon, .otf, .ttf';
const maxSize = 50;
export const MAX_FILE_SIZE_FOR_UPLOAD = maxSize * 1024 * 1024;

export const MAX_UPLOAD_LIMIT = maxSize + ' MB';

export const MAX_FILE_SIZE_FOR_PREVIEW = 20 * 1024 * 1024;

export const shareDefaultsConfig = [
  {
    title: 'isSharedOnce',
    identifier: 'isSharedOnce',
    type: 'toggle',
  },
  {
    title: 'sharedIn',
    identifier: 'sharedIn',
    type: 'button',
  },
  {
    title: 'sharedOut',
    identifier: 'sharedOut',
    type: 'button',
  },
];
export const TOOLTIP_B_CARD_FIELDS = ['workerId', 'workEmail', 'workMobile', 'deskPhone', 'workPager', 'workFax'];

export const ProfilePictureSizes = {
  X_SMALL: 12,
  SMALL: 16,
  MEDIUM: 20,
  LARGE: 24,
  X_LARGE: 34,
  XX_LARGE: 80,
};
